/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Button from '../../Button/Button';
import Dialog from '../../Dialog/Dialog';
import Entitytypeview from '../../Entitytypeview/Entitytypeview';
import Service from '../../Util/Service';
import $ from '../../Util/Util';
import './Entitytype.css';

/**
 * Represents the entity type maintenance screen.
 */

export default class Entitytype extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        entitytypes:              PropTypes.object,
        groups:                   PropTypes.array,
        attributes:               PropTypes.array,
        onBack:                   PropTypes.func.isRequired
    }

    /**
     * Event that fires when the user closes the entity type maintenance.
     */  

    _onCloseMaintenance = () => {

        // Closing the popup screen

        this.props.onBack();
    }

    /**
     * Event that fires when the user wants to delete the seleced entity type.
     */

    _onDeleteEntitytype = () => {
        this.deleteConfirmDialog.open();
    }

    /**
     * Event that fires when the user wants to cancel the deletion of the
     * selected entity type.
     */

    _cancelDelete = () => {
        this.deleteConfirmDialog.close();
    }

    /**
     * Deletes the selected entity type.
     */


    _delete = () => {

        // Closing confirm dialog

        this.deleteConfirmDialog.close().then(() => {

            // Showing progress indicator

            this.props.onLoading(true);

            // Deleting the entity type

            Service.deleteEntitytype(this.props.entitytype.id).then(() => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing confirm

                $.fireEvent('snackbar', { message: this.props.context.locale.entitytype.deletedmessage });

                // Closing window

                this.props.onBack();
            }).catch((error) => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
            });
        });
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.entitytype.id ? 
            this.props.context.locale.entitytype.title.modifyentitytype :
            this.props.context.locale.entitytype.title.newentitytype
        );
    }

    /** 
     * Entity type maintenance screen renderer.
     */

    render() {
        return (
            <div className="entitytype">

                {/* Entity type view and maintenance */}

                <Entitytypeview context={this.props.context} groups={this.props.groups} attributes={this.props.attributes} entitytype={this.props.entitytype} onLoading={this.props.onLoading} onClose={this._onCloseMaintenance} onDelete={this._onDeleteEntitytype} />

                {/* Delete confirm dialog */}

                <Dialog ref={c => {this.deleteConfirmDialog = c;}} width={360} height={104} closetooltip={this.props.context.locale.entitytype.deletedialog.close}>

                    {/* Message */}

                    <div className="entitytype-deletedialog-title">{this.props.context.locale.entitytype.deletedialog.message}</div>
                    <div className="entitytype-deletedialog-entitytypename">{this.props.entitytype.name}</div>

                    {/* Buttons */}

                    <div className="horizontal">

                        {/* Spacer */}

                        <div className="flex"></div>

                        {/* Delete */}

                        <Button label={this.props.context.locale.entitytype.deletedialog.buttons.yes.label} tooltip={this.props.context.locale.entitytype.deletedialog.buttons.yes.tooltip} width={60} onTouch={this._delete} />

                        {/* Cancel */}

                        <Button label={this.props.context.locale.entitytype.deletedialog.buttons.cancel.label} tooltip={this.props.context.locale.entitytype.deletedialog.buttons.cancel.tooltip} width={60} leftgap={8} onTouch={this._cancelDelete} />
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Entitytype/Entitytype.js